import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Loading = () => {
    return (_jsxs("div", { className: "sudoku-controls__loading", children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {})] }));
};
export default Loading;
